import { createContext } from 'react'
import { ElementsControllerProps } from '@/reducers'

export type ModalTextProps = {
  title: string,
  description: string,
  buttonText?: string
}

export type ContextActionsProps = {
  changePasswordModalOpen: () => void,
  changePasswordModalClose: () => void,
  logoutConfirmationModalOpen: () => void,
  logoutConfirmationModalClose: () => void,
  confirmDialogModalOpen: (modalText: ModalTextProps) => void,
  confirmDialogModalClose: () => void,
  addMenuModalOpen: () => void,
  addMenuModalClose: () => void,
  createTenantFormModalOpen: () => void,
  createTenantFormModalClose: () => void,
  createOwnerFormModalOpen: () => void,
  createOwnerFormModalClose: () => void,
  createSupplierFormModalOpen: () => void,
  createSupplierFormModalClose: () => void,
  state: ElementsControllerProps
}

export const OpeningElementsControllerContext = createContext<ContextActionsProps | null>(null)
